import Vue from 'vue/dist/vue.common';
import { apolloProvider } from "../vue-apollo-init";
import gql from 'graphql-tag';
import _ from 'lodash';

export class Header_Comps {
    constructor(){

        this.header_tag_selected = false;
        this.search_input = false;
        this.search_button = false;
        this.search_text_input = false;
    }
    init(){
        let store = window.store;
        let router = window.router;
  
        this.header_tag_selected = new Vue ({
            el: '#header-tag-selected',
            template: '#header-tag-selected-template',
            methods: {
              clear_tag: function() {
                store.setTag(false);
              }
            },
            data: store.state,
          })
      
        this.search_input = new Vue ({
            el: '#search',
            methods: {
              onEnter: function() {
                let value = document.getElementById('search').value;
                store.setSearchText(value);
              },
              onClick: function() {
                store.setSearchActive(true);
                document.getElementById("search_text").focus();
              }
            }
          })
      
        this.search_button = new Vue ({
            el: '#search-icon',
            methods: {
              searchClick() {
                store.setSearchActive(true);
                document.getElementById("search_text").focus();
              }
            } 
          })
      
          this.search_text_input = new Vue ({
            el: '#header-search-text',
            template: '#header-search-text-template',
            data: store.state,
            computed: {
              search: {
                get () {
                  return store.state.posts_search_text
                },
                /*set (value) {
                  console.log('happening');
                  document.getElementById("cursor_search").classList.add('hide');
                  this.throttled_setSearchText(value);
                }*/
              }
            },
            methods: {
              clear_search: function() {
                store.setSearchText('');
                store.setSearchActive(false);
                document.getElementById("cursor_search").classList.remove('hide');
              },
              throttled_setSearchText:_.debounce( function(value){
                store.setSearchText(value);
              }, 500, { 'maxWait': 1000 }),
              onKeyup: function() {
                this.text_added = true;
              },
              update_search: function(event){                
                document.getElementById("cursor_search").classList.add('hide');
                this.throttled_setSearchText(event.target.value);
              }
            },
          })
        
    }
}